import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Azuredevopstemplate from "../../component/course/azure-devops";


export default class Azuredevopsinchennai extends Component {

  render() {
    
    const title ="Azure DevOps"
    const url ="azure-devops"
    const url1 ="-training-in-chennai"
    const location = "chennai" 
    const location1="Training in Chennai"

    return (
      <>
          <NextSeoModule
             title={`${title} ${location1} - learnsoft.org `}
            description={`Supercharge Your Career with Premier Azure DevOps Training in Chennai! Hands-On Learning for IT Professionals. Enroll Now for Success!`}
           url={`course/${url}${url1}`}
            img={`course/${url}.webp`}
            keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}          />         
        <Layout navbarBackgroundColor="#281E1E">
          <Azuredevopstemplate url1={url1} url={url} title={title} relatedlocation={"course"} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
